"use client";

import { motion, useInView } from "framer-motion";
import Image from "next/image";
import { useRef } from "react";

interface PageHeroProps {
	title: string;
	image: string;
	alt?: string;
}

export default function PageHero({ title, image, alt = "" }: PageHeroProps) {
	const ref = useRef(null);
	const isInView = useInView(ref, { once: true, amount: 0.3 });

	return (
		<section
			ref={ref}
			className="relative h-64 md:h-80 lg:h-96 w-full overflow-hidden"
		>
			<Image
				src={image}
				alt={alt || title}
				fill
				priority
				className="object-cover"
				quality={90}
			/>

			<div className="absolute inset-0 bg-black/50" />

			<div className="absolute inset-0 flex items-center justify-center">
				<motion.h1
					initial={{ opacity: 0, y: -20 }}
					animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: -20 }}
					transition={{ duration: 0.8, ease: "easeOut" }}
					className="text-4xl md:text-5xl lg:text-6xl font-bold text-white text-center px-4 uppercase tracking-wide"
				>
					{title}
				</motion.h1>
			</div>
		</section>
	);
}
